import React, { useState } from 'react'
import styles from './styles.module.scss'
import Activity from './Activity'
import RatingBoxes from './RatingBoxes'
import SectionTitle from '../common/SectionTitle'
import { useTranslation } from 'react-i18next'
import MostActiveMembers from './MostActiveMembers'
import QuickStats from './QuickStats'
import MostActiveGroups from './MostActiveGroups'
import MostSuccessfulMixrs from './MostSuccessfulMixrs'

function GroupWPDigest({ type, objectId, digestData, activityData, loading }) {
  const { t } = useTranslation()
  const [selectedDuration, setSelectedDuration] = useState({
    label: t('durationOptions.pastNDays', { n: 30 }),
    value: '4W'
  })

  const changeDuration = (newDuration) => {
    setSelectedDuration(newDuration)
  }

  return (
    <React.Fragment>
      <SectionTitle
        showDurationDropdown={true}
        selectedDuration={selectedDuration}
        handleDurationChange={changeDuration}
      />

      <div className={styles.digest}>
        {type === 'workplace' && (
          <div className={`${styles.row} ${styles.rowRatingBoxes}`}>
            <RatingBoxes type={type} data={digestData} selectedDuration={selectedDuration.value} />
          </div>
        )}
        <div className={`${styles.row}`}>
          <Activity
            type={type}
            data={activityData}
            objectId={objectId}
            loading={loading}
            selectedDuration={selectedDuration.value}
          />
        </div>
        {type === 'group' && (
          <div className={styles.row}>
            <MostActiveMembers objectId={objectId} data={digestData} selectedDuration={selectedDuration.value} />
          </div>
        )}
        {type === 'group' && (
          <div className={`${styles.row} ${styles.rowRatingBoxes}`}>
            <RatingBoxes type={type} data={digestData} selectedDuration={selectedDuration.value} />
          </div>
        )}

        {type === 'workplace' && (
          <React.Fragment>
            <div className={styles.row}>
              <QuickStats data={activityData?.Quick_Stats} selectedDuration={selectedDuration.value} />
            </div>
            <div className={`${styles.row} ${styles.rowMostActive}`}>
              <MostActiveGroups data={activityData?.Most_Active_Groups} selectedDuration={selectedDuration.value} />
              <MostSuccessfulMixrs
                data={activityData?.Most_Succesful_mixrs}
                selectedDuration={selectedDuration.value}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  )
}

export default GroupWPDigest
